export default __webpack_public_path__ + "static/media/edtech-fig.fb235848.jpeg";